import { render, staticRenderFns } from "./matching-results-loading.vue?vue&type=template&id=48165454&"
import script from "./matching-results-loading.vue?vue&type=script&lang=ts&"
export * from "./matching-results-loading.vue?vue&type=script&lang=ts&"
import style0 from "./matching-results-loading.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports